import WindsorApi from '../api/WindsorApi';
import { decorate, observable } from 'mobx';

class CspGroupStore {
    private windsorApi: WindsorApi;

    public groups: any = null;

    constructor(windsorApi: WindsorApi) {
        this.windsorApi = windsorApi;
        this._loadGroups();
    }

    _loadGroups() {
        this.windsorApi.getCspGroups().then(resp => {
            this.groups = resp.Groups.reduce((accumulator, group) => {
                accumulator[group.ID] = group.Name;
                return accumulator;
            }, {});
        });
    }

}

decorate(CspGroupStore, {
    groups: observable
});

export default CspGroupStore;
